import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 p-3" }
const _hoisted_2 = { class: "max-w-6xl mx-auto" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = {
  class: "relative rounded-2xl p-4 shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden w-full",
  style: {"background":"linear-gradient(135deg, #60A5FA 0%, #3B82F6 25%, #1D4ED8 50%, #1E40AF 75%, #1E3A8A 100%)"}
}
const _hoisted_5 = { class: "relative z-10" }
const _hoisted_6 = { class: "flex items-center space-x-4 mb-3" }
const _hoisted_7 = { class: "text-2xl font-bold text-white" }
const _hoisted_8 = { class: "text-white/90 text-lg font-medium" }
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6 items-start" }
const _hoisted_11 = { class: "bg-white rounded-2xl border border-gray-200 p-4 shadow-lg hover:shadow-xl transition-shadow duration-300" }
const _hoisted_12 = { class: "flex items-center justify-between mb-4" }
const _hoisted_13 = { class: "flex items-center gap-3" }
const _hoisted_14 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_17 = { class: "text-sm font-semibold text-gray-900 mb-1" }
const _hoisted_18 = { class: "text-gray-500 text-xs" }
const _hoisted_19 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_20 = { class: "flex items-center justify-between" }
const _hoisted_21 = { class: "flex items-center gap-3" }
const _hoisted_22 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_23 = { class: "flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "flex gap-2 pt-4 border-t border-gray-200" }
const _hoisted_27 = {
  key: 0,
  class: "flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded-lg text-sm"
}
const _hoisted_28 = { class: "bg-white rounded-2xl border border-gray-200 p-4 shadow-lg hover:shadow-xl transition-shadow duration-300" }
const _hoisted_29 = { class: "mb-6" }
const _hoisted_30 = { class: "flex items-center justify-between mb-4" }
const _hoisted_31 = { class: "flex items-center gap-3" }
const _hoisted_32 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_33 = { class: "text-xs text-gray-600" }
const _hoisted_34 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_35 = { class: "flex items-start justify-between mb-3" }
const _hoisted_36 = { class: "flex items-center gap-3" }
const _hoisted_37 = ["d"]
const _hoisted_38 = { class: "text-sm font-medium text-gray-900 mb-1" }
const _hoisted_39 = { class: "flex items-center gap-2" }
const _hoisted_40 = { class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-600" }
const _hoisted_41 = { class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-600" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "text-xs text-gray-600 mb-3" }
const _hoisted_44 = { class: "space-y-2" }
const _hoisted_45 = { class: "text-xs font-medium text-gray-700 mb-1" }
const _hoisted_46 = { class: "flex flex-wrap gap-1" }
const _hoisted_47 = { class: "space-y-4" }
const _hoisted_48 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_49 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_50 = { class: "text-gray-500 max-w-sm mx-auto" }
const _hoisted_51 = {
  key: 1,
  class: "grid grid-cols-1 gap-4"
}
const _hoisted_52 = { class: "flex items-start justify-between mb-3" }
const _hoisted_53 = { class: "flex items-center gap-3" }
const _hoisted_54 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_55 = { class: "text-xs text-gray-500" }
const _hoisted_56 = { class: "flex items-center gap-2" }
const _hoisted_57 = { class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-600" }
const _hoisted_58 = ["onClick", "title"]
const _hoisted_59 = ["onClick", "title"]
const _hoisted_60 = { class: "space-y-2" }
const _hoisted_61 = { class: "text-xs font-medium text-gray-700 mb-1" }
const _hoisted_62 = {
  key: 0,
  class: "space-y-1"
}
const _hoisted_63 = { class: "text-gray-900 truncate flex-1 font-medium" }
const _hoisted_64 = { class: "text-gray-500 text-xs shrink-0 bg-gray-100 px-2 py-0.5 rounded" }
const _hoisted_65 = {
  key: 0,
  class: "text-xs text-gray-500 ml-4"
}
const _hoisted_66 = {
  key: 1,
  class: "text-xs text-gray-500 italic bg-gray-50 p-2 rounded text-center"
}
const _hoisted_67 = { class: "mt-6 p-4 bg-amber-50 border border-amber-200 rounded-xl" }
const _hoisted_68 = { class: "flex items-start gap-3" }
const _hoisted_69 = { class: "text-amber-800" }
const _hoisted_70 = { class: "font-semibold mb-2" }
const _hoisted_71 = { class: "text-sm text-amber-700" }
const _hoisted_72 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_73 = { class: "bg-white rounded-xl shadow-2xl w-full max-w-lg mx-4 z-10 relative border border-gray-200 max-h-[85vh] overflow-hidden" }
const _hoisted_74 = {
  class: "px-6 py-4",
  style: {"background":"linear-gradient(135deg, #3B82F6 0%, #2563EB 50%, #1D4ED8 100%)"}
}
const _hoisted_75 = { class: "flex items-center justify-between" }
const _hoisted_76 = { class: "flex items-center gap-3" }
const _hoisted_77 = { class: "text-lg font-semibold text-white" }
const _hoisted_78 = { class: "text-white/90 text-sm" }
const _hoisted_79 = { class: "p-6 space-y-6" }
const _hoisted_80 = { class: "text-center" }
const _hoisted_81 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_82 = { class: "text-gray-600 text-sm" }
const _hoisted_83 = { class: "space-y-4" }
const _hoisted_84 = { class: "block text-sm font-semibold text-gray-900 mb-2" }
const _hoisted_85 = ["placeholder"]
const _hoisted_86 = { class: "block text-sm font-semibold text-gray-900 mb-2" }
const _hoisted_87 = { class: "flex items-center gap-3" }
const _hoisted_88 = { class: "flex-1" }
const _hoisted_89 = { class: "flex items-center gap-2 p-3 bg-gray-50 rounded-lg border border-gray-200" }
const _hoisted_90 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_91 = { class: "text-xs text-gray-500" }
const _hoisted_92 = { class: "px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between" }
const _hoisted_93 = { class: "text-xs text-gray-500" }
const _hoisted_94 = { class: "flex gap-2" }
const _hoisted_95 = ["disabled"]
const _hoisted_96 = {
  key: 1,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_97 = { class: "bg-white rounded-xl shadow-2xl w-full max-w-lg mx-4 z-10 relative border border-gray-200 max-h-[85vh] overflow-hidden" }
const _hoisted_98 = {
  class: "px-6 py-4",
  style: {"background":"linear-gradient(135deg, #DC2626 0%, #B91C1C 50%, #991B1B 100%)"}
}
const _hoisted_99 = { class: "flex items-center justify-between" }
const _hoisted_100 = { class: "flex items-center gap-3" }
const _hoisted_101 = { class: "text-lg font-semibold text-white" }
const _hoisted_102 = { class: "text-white/90 text-sm" }
const _hoisted_103 = { class: "p-6 space-y-6" }
const _hoisted_104 = { class: "text-center" }
const _hoisted_105 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_106 = { class: "text-gray-600 text-sm" }
const _hoisted_107 = { class: "p-4 bg-red-50 border border-red-200 rounded-lg" }
const _hoisted_108 = { class: "flex items-start gap-3" }
const _hoisted_109 = { class: "text-red-800" }
const _hoisted_110 = { class: "font-semibold text-sm mb-1" }
const _hoisted_111 = { class: "text-sm text-red-700" }
const _hoisted_112 = { class: "px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between" }
const _hoisted_113 = { class: "text-xs text-gray-500" }
const _hoisted_114 = { class: "flex gap-2" }
const _hoisted_115 = { class: "p-4" }
const _hoisted_116 = { class: "flex items-start gap-3" }
const _hoisted_117 = {
  key: 0,
  class: "w-4 h-4 text-emerald-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_118 = {
  key: 1,
  class: "w-4 h-4 text-red-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_119 = {
  key: 2,
  class: "w-4 h-4 text-blue-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_120 = { class: "flex-1 min-w-0" }
const _hoisted_121 = { class: "flex items-center justify-between" }
const _hoisted_122 = { class: "text-sm mt-1" }
const _hoisted_123 = {
  key: 3,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_124 = { class: "bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 z-10 relative border border-gray-200 max-h-[80vh] overflow-hidden" }
const _hoisted_125 = {
  key: 0,
  class: "flex flex-col h-full"
}
const _hoisted_126 = {
  class: "px-6 py-4",
  style: {"background":"linear-gradient(135deg, #3B82F6 0%, #2563EB 50%, #1D4ED8 100%)"}
}
const _hoisted_127 = { class: "flex items-center justify-between" }
const _hoisted_128 = { class: "flex items-center gap-3" }
const _hoisted_129 = { class: "text-lg font-semibold text-white" }
const _hoisted_130 = { class: "text-white/90 text-sm" }
const _hoisted_131 = { class: "flex-1 p-6" }
const _hoisted_132 = { class: "max-w-md mx-auto" }
const _hoisted_133 = { class: "text-center mb-6" }
const _hoisted_134 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_135 = { class: "text-gray-600" }
const _hoisted_136 = { class: "space-y-4" }
const _hoisted_137 = { class: "block text-sm font-semibold text-gray-900 mb-2" }
const _hoisted_138 = ["placeholder"]
const _hoisted_139 = { class: "mt-6 p-4 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg border border-gray-200" }
const _hoisted_140 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_141 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_142 = { class: "text-xs text-gray-500" }
const _hoisted_143 = { class: "text-xs text-gray-500" }
const _hoisted_144 = { class: "px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between" }
const _hoisted_145 = { class: "text-xs text-gray-500" }
const _hoisted_146 = { class: "flex gap-2" }
const _hoisted_147 = ["disabled"]
const _hoisted_148 = {
  key: 1,
  class: "flex h-[80vh]"
}
const _hoisted_149 = { class: "w-1/2 border-r border-gray-200 flex flex-col bg-gray-50" }
const _hoisted_150 = {
  class: "px-4 py-3",
  style: {"background":"linear-gradient(135deg, #3B82F6 0%, #2563EB 50%, #1D4ED8 100%)"}
}
const _hoisted_151 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_152 = { class: "text-sm font-semibold text-white" }
const _hoisted_153 = { class: "text-white/90 text-xs" }
const _hoisted_154 = { class: "flex-1 p-3 overflow-y-auto" }
const _hoisted_155 = { class: "grid grid-cols-1 gap-2" }
const _hoisted_156 = ["onClick"]
const _hoisted_157 = { class: "flex items-center gap-2" }
const _hoisted_158 = { class: "w-8 h-8 bg-blue-100 group-hover:bg-blue-200 rounded flex items-center justify-center transition-colors duration-200" }
const _hoisted_159 = {
  class: "w-4 h-4 text-blue-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_160 = ["d"]
const _hoisted_161 = { class: "text-sm font-medium text-gray-900 group-hover:text-blue-600 transition-colors duration-200" }
const _hoisted_162 = { class: "text-xs text-gray-500" }
const _hoisted_163 = { class: "w-1/2 flex flex-col bg-white" }
const _hoisted_164 = {
  class: "px-4 py-3",
  style: {"background":"linear-gradient(135deg, #3B82F6 0%, #2563EB 50%, #1D4ED8 100%)"}
}
const _hoisted_165 = { class: "flex items-center justify-between" }
const _hoisted_166 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_167 = { class: "text-sm font-semibold text-white" }
const _hoisted_168 = { class: "text-white/90 text-xs" }
const _hoisted_169 = ["disabled"]
const _hoisted_170 = { class: "flex-1 p-3 overflow-y-auto" }
const _hoisted_171 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_172 = { class: "text-sm font-medium text-gray-900 mb-1" }
const _hoisted_173 = { class: "text-xs text-gray-500" }
const _hoisted_174 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_175 = { class: "flex items-start justify-between" }
const _hoisted_176 = { class: "flex-1 min-w-0" }
const _hoisted_177 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_178 = { class: "flex-1" }
const _hoisted_179 = { class: "flex items-center gap-2" }
const _hoisted_180 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_181 = {
  key: 0,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800"
}
const _hoisted_182 = { class: "flex items-center gap-2 mt-0.5" }
const _hoisted_183 = { class: "text-xs text-gray-600" }
const _hoisted_184 = { class: "text-xs text-gray-500 truncate" }
const _hoisted_185 = { class: "flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200" }
const _hoisted_186 = ["onClick"]
const _hoisted_187 = ["onClick"]
const _hoisted_188 = { class: "px-4 py-3 bg-gray-50 border-t border-gray-200 flex items-center justify-between" }
const _hoisted_189 = { class: "text-xs text-gray-500" }
const _hoisted_190 = {
  key: 4,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_191 = { class: "bg-white rounded-xl shadow-2xl w-full max-w-lg mx-4 z-10 relative border border-gray-200 max-h-[85vh] overflow-hidden" }
const _hoisted_192 = {
  class: "px-6 py-4",
  style: {"background":"linear-gradient(135deg, #A855F7 0%, #9333EA 50%, #7C3AED 100%)"}
}
const _hoisted_193 = { class: "flex items-center justify-between" }
const _hoisted_194 = { class: "flex items-center gap-3" }
const _hoisted_195 = { class: "text-lg font-semibold text-white" }
const _hoisted_196 = { class: "text-white/90 text-sm" }
const _hoisted_197 = { class: "p-6 space-y-4 max-h-[70vh] overflow-y-auto" }
const _hoisted_198 = { class: "block text-sm font-semibold text-gray-900 mb-2" }
const _hoisted_199 = ["placeholder"]
const _hoisted_200 = { class: "block text-sm font-semibold text-gray-900 mb-2" }
const _hoisted_201 = {
  value: "",
  disabled: ""
}
const _hoisted_202 = ["value"]
const _hoisted_203 = { class: "block text-sm font-semibold text-gray-900 mb-2" }
const _hoisted_204 = ["placeholder"]
const _hoisted_205 = { class: "flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200" }
const _hoisted_206 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_207 = { class: "text-xs text-gray-500" }
const _hoisted_208 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_209 = { class: "flex items-center gap-2" }
const _hoisted_210 = { class: "block text-sm font-semibold text-gray-900" }
const _hoisted_211 = { class: "text-xs text-gray-500" }
const _hoisted_212 = { class: "space-y-2" }
const _hoisted_213 = { class: "w-5 h-5 bg-purple-100 rounded-full flex items-center justify-center text-xs font-bold text-purple-600" }
const _hoisted_214 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_215 = ["onClick"]
const _hoisted_216 = { class: "flex items-center justify-center gap-1" }
const _hoisted_217 = { class: "px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between" }
const _hoisted_218 = { class: "text-xs text-gray-500" }
const _hoisted_219 = { class: "flex gap-2" }
const _hoisted_220 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "absolute inset-0 overflow-hidden" }, [
            _createElementVNode("div", {
              class: "absolute -top-20 -right-20 w-40 h-40 rounded-full opacity-20",
              style: {"background":"radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%)"}
            })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "relative flex-shrink-0" }, [
                _createElementVNode("div", {
                  class: "w-16 h-16 rounded-full flex items-center justify-center border-3 border-white/70 shadow-xl",
                  style: {"background":"linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)"}
                }, [
                  _createElementVNode("svg", {
                    class: "w-8 h-8 text-blue-600",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 0 1 5.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 0 1 9.288 0M15 7a3 3 0 11-6 0 3 3 0 0 1 6 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    })
                  ])
                ])
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.directT('settings.customersSettings.title')), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.directT('settings.customersSettings.subtitle')), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_SettingsNav)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[31] || (_cache[31] = _createElementVNode("div", {
                class: "w-8 h-8 rounded-lg flex items-center justify-center",
                style: {"background-color":"#1E40AF"}
              }, [
                _createElementVNode("svg", {
                  class: "w-4 h-4 text-white",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                  })
                ])
              ], -1)),
              _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.title')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_ctx.statusList.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-3" }, [
                    _createElementVNode("svg", {
                      class: "w-6 h-6 text-blue-600",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.noStatusesTitle')), 1),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.noStatusesDescription')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (status, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: status.id,
                      class: "group bg-gray-50 rounded-lg border border-gray-200 p-3 hover:bg-gray-100 transition-all duration-200"
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", {
                            class: "w-4 h-4 rounded-full",
                            style: _normalizeStyle({ backgroundColor: status.color })
                          }, null, 4),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(status.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.editStatus(index)),
                            class: "w-8 h-8 rounded-lg bg-blue-100 hover:bg-blue-200 text-blue-600 transition-all duration-200 flex items-center justify-center"
                          }, _cache[33] || (_cache[33] = [
                            _createElementVNode("svg", {
                              class: "w-4 h-4",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                              })
                            ], -1)
                          ]), 8, _hoisted_24),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.confirmDeleteStatus(index)),
                            class: "w-8 h-8 rounded-lg bg-red-100 hover:bg-red-200 text-red-600 transition-all duration-200 flex items-center justify-center"
                          }, _cache[34] || (_cache[34] = [
                            _createElementVNode("svg", {
                              class: "w-4 h-4",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              })
                            ], -1)
                          ]), 8, _hoisted_25)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewStatus && _ctx.addNewStatus(...args))),
              class: "flex-1 px-4 py-2 text-white rounded-lg font-medium text-sm transition-all duration-200 flex items-center justify-center gap-2 shadow-md hover:shadow-lg",
              style: {"background":"linear-gradient(135deg, #3B82F6 0%, #1E40AF 100%)"}
            }, [
              _cache[35] || (_cache[35] = _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.addStatus')), 1)
            ]),
            (_ctx.saving)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _cache[36] || (_cache[36] = _createElementVNode("svg", {
                    class: "w-4 h-4 animate-spin",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.customersSettings.autoSaving.saving')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _cache[37] || (_cache[37] = _createElementVNode("div", {
                  class: "w-8 h-8 rounded-lg flex items-center justify-center",
                  style: {"background":"linear-gradient(135deg, #3B82F6, #2563EB)"}
                }, [
                  _createElementVNode("svg", {
                    class: "w-4 h-4 text-white",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("h4", _hoisted_32, _toDisplayString(_ctx.directT('settings.customersSettings.existingCards.title')), 1),
                  _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.directT('settings.customersSettings.existingCards.description')), 1)
                ])
              ]),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewCard && _ctx.addNewCard(...args))),
                class: "px-4 py-2 text-white text-sm font-medium rounded-lg transition-all duration-200 flex items-center gap-2 shadow-md hover:shadow-lg transform hover:scale-105",
                style: {"background":"linear-gradient(135deg, #3B82F6, #2563EB)"}
              }, [
                _cache[38] || (_cache[38] = _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.customersSettings.existingCards.addNewCard')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultCards, (card, cardIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: card.id,
                  class: "group bg-white rounded-xl border border-gray-200 p-4 shadow-sm hover:shadow-md transition-all duration-200"
                }, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-8 h-8 rounded-lg flex items-center justify-center shadow-sm", card.iconBg])
                      }, [
                        (_openBlock(), _createElementBlock("svg", {
                          class: _normalizeClass(["w-4 h-4", card.iconColor]),
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: card.iconPath
                          }, null, 8, _hoisted_37)
                        ], 2))
                      ], 2),
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", _hoisted_38, _toDisplayString(card.title), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.directT('settings.customersSettings.existingCards.statusActive')), 1),
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.directT('settings.customersSettings.existingCards.statusBuiltIn')), 1),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.editDefaultCard(cardIndex)),
                        class: "opacity-0 group-hover:opacity-100 w-8 h-8 rounded-lg bg-blue-100 hover:bg-blue-200 text-blue-600 transition-all duration-200 flex items-center justify-center"
                      }, _cache[39] || (_cache[39] = [
                        _createElementVNode("svg", {
                          class: "w-4 h-4",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          })
                        ], -1)
                      ]), 8, _hoisted_42)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, _toDisplayString(card.description), 1),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.directT('settings.customersSettings.existingCards.includedFields')), 1),
                    _createElementVNode("div", _hoisted_46, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.fields, (field) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: field,
                          class: "px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs"
                        }, _toDisplayString(field), 1))
                      }), 128))
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            (_ctx.systemAreas.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _cache[40] || (_cache[40] = _createElementVNode("div", { class: "mx-auto w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-4" }, [
                    _createElementVNode("svg", {
                      class: "w-8 h-8 text-blue-600",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("h4", _hoisted_49, _toDisplayString(_ctx.directT('settings.customersSettings.existingCards.noCardsTitle')), 1),
                  _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.directT('settings.customersSettings.existingCards.noCardsDescription')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemAreas, (area, areaIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: area.id,
                      class: "group bg-white rounded-xl border border-gray-200 p-4 hover:shadow-md transition-all duration-200 shadow-sm"
                    }, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center shadow-sm" }, [
                            _createElementVNode("svg", {
                              class: "w-4 h-4 text-blue-600",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                              })
                            ])
                          ], -1)),
                          _createElementVNode("div", null, [
                            _createElementVNode("h3", _hoisted_54, _toDisplayString(area.title), 1),
                            _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.t('settings.customersSettings.fieldsConfigured', { count: area.fields.length })), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.directT('settings.customersSettings.existingCards.statusCustom')), 1),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.editArea(areaIndex)),
                            class: "w-8 h-8 rounded-lg bg-blue-100 hover:bg-blue-200 text-blue-600 transition-all duration-200 flex items-center justify-center",
                            title: _ctx.directT('settings.customersSettings.existingCards.editCard')
                          }, _cache[42] || (_cache[42] = [
                            _createElementVNode("svg", {
                              class: "w-4 h-4",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                              })
                            ], -1)
                          ]), 8, _hoisted_58),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.deleteArea(areaIndex)),
                            class: "w-8 h-8 rounded-lg bg-red-100 hover:bg-red-200 text-red-600 transition-all duration-200 flex items-center justify-center",
                            title: _ctx.directT('settings.customersSettings.existingCards.deleteCard')
                          }, _cache[43] || (_cache[43] = [
                            _createElementVNode("svg", {
                              class: "w-4 h-4",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              })
                            ], -1)
                          ]), 8, _hoisted_59)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.directT('settings.customersSettings.existingCards.fields')), 1),
                        (area.fields.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(area.fields.slice(0, 3), (field, fieldIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: field.id || fieldIndex,
                                  class: "flex items-center gap-2 text-xs"
                                }, [
                                  _cache[44] || (_cache[44] = _createElementVNode("div", { class: "w-2 h-2 rounded-full bg-blue-400" }, null, -1)),
                                  _createElementVNode("span", _hoisted_63, _toDisplayString(field.label), 1),
                                  _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.getFieldTypeLabel(field.type)), 1)
                                ]))
                              }), 128)),
                              (area.fields.length > 3)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.directT('settings.customersSettings.existingCards.moreFields', { count: area.fields.length - 3 })), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.directT('settings.customersSettings.existingCards.noFieldsConfigured')), 1))
                      ])
                    ]))
                  }), 128))
                ]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          _cache[45] || (_cache[45] = _createElementVNode("div", { class: "w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center mt-0.5 flex-shrink-0" }, [
            _createElementVNode("svg", {
              class: "w-4 h-4 text-amber-600",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.importantTitle')), 1),
            _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.important')), 1)
          ])
        ])
      ])
    ]),
    (_ctx.showStatusModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/30 backdrop-blur-md",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeStatusModal && _ctx.closeStatusModal(...args)))
          }),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _cache[46] || (_cache[46] = _createElementVNode("div", { class: "w-8 h-8 bg-white/30 rounded-lg flex items-center justify-center border border-white/20" }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 text-white",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_77, _toDisplayString(_ctx.editingStatusIndex === -1 ? _ctx.directT('settings.customersSettings.statusManagement.addStatusTitle') : _ctx.directT('settings.customersSettings.statusManagement.editStatusTitle')), 1),
                    _createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.editingStatusIndex === -1 ? _ctx.directT('settings.customersSettings.statusManagement.createStatusDescription') : _ctx.directT('settings.customersSettings.statusManagement.updateStatusDescription')), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeStatusModal && _ctx.closeStatusModal(...args))),
                  class: "w-8 h-8 bg-white/30 hover:bg-white/40 rounded-lg flex items-center justify-center transition-all duration-200 border border-white/20"
                }, _cache[47] || (_cache[47] = [
                  _createElementVNode("svg", {
                    class: "w-4 h-4 text-white",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _cache[48] || (_cache[48] = _createElementVNode("div", { class: "w-16 h-16 bg-gradient-to-br from-blue-100 to-sky-100 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-md" }, [
                  _createElementVNode("svg", {
                    class: "w-8 h-8 text-blue-600",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                    })
                  ])
                ], -1)),
                _createElementVNode("h4", _hoisted_81, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.statusConfigurationTitle')), 1),
                _createElementVNode("p", _hoisted_82, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.statusConfigurationDescription')), 1)
              ]),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.statusName')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editingStatus.name) = $event)),
                    type: "text",
                    class: "w-full px-3 py-2.5 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-100 focus:border-blue-500 bg-gray-50 text-gray-900 transition-all duration-300 placeholder:text-gray-400",
                    placeholder: _ctx.directT('settings.customersSettings.statusManagement.statusNamePlaceholder')
                  }, null, 8, _hoisted_85), [
                    [_vModelText, _ctx.editingStatus.name]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.statusColor')), 1),
                  _createElementVNode("div", _hoisted_87, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editingStatus.color) = $event)),
                      type: "color",
                      class: "w-16 h-12 rounded-lg border-2 border-gray-200 focus:ring-2 focus:ring-blue-100 focus:border-blue-500 transition-all duration-300"
                    }, null, 512), [
                      [_vModelText, _ctx.editingStatus.color]
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("div", {
                          class: "w-6 h-6 rounded-full border-2 border-white shadow-sm",
                          style: _normalizeStyle({ backgroundColor: _ctx.editingStatus.color })
                        }, null, 4),
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_90, _toDisplayString(_ctx.editingStatus.name || _ctx.directT('settings.customersSettings.statusManagement.statusPreview')), 1),
                          _createElementVNode("p", _hoisted_91, _toDisplayString(_ctx.editingStatus.color), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.colorTip')), 1),
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeStatusModal && _ctx.closeStatusModal(...args))),
                  class: "px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 text-sm font-medium"
                }, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.cancel')), 1),
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveStatus && _ctx.saveStatus(...args))),
                  disabled: !_ctx.editingStatus.name.trim(),
                  class: "px-6 py-2 text-white rounded-lg hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 text-sm font-medium shadow-md disabled:shadow-none",
                  style: {"background":"linear-gradient(135deg, #3B82F6 0%, #2563EB 50%, #1D4ED8 100%)"}
                }, _toDisplayString(_ctx.editingStatusIndex === -1 ? _ctx.directT('settings.customersSettings.statusManagement.add') : _ctx.directT('settings.customersSettings.statusManagement.update')), 9, _hoisted_95)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/30 backdrop-blur-md",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args)))
          }),
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _cache[49] || (_cache[49] = _createElementVNode("div", { class: "w-8 h-8 bg-white/30 rounded-lg flex items-center justify-center border border-white/20" }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 text-white",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_101, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.confirmDeleteTitle')), 1),
                    _createElementVNode("p", _hoisted_102, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.actionCannotBeUndone')), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                  class: "w-8 h-8 bg-white/30 hover:bg-white/40 rounded-lg flex items-center justify-center transition-all duration-200 border border-white/20"
                }, _cache[50] || (_cache[50] = [
                  _createElementVNode("svg", {
                    class: "w-4 h-4 text-white",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("div", _hoisted_104, [
                _cache[51] || (_cache[51] = _createElementVNode("div", { class: "w-16 h-16 bg-gradient-to-br from-red-100 to-rose-100 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-md" }, [
                  _createElementVNode("svg", {
                    class: "w-8 h-8 text-red-600",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    })
                  ])
                ], -1)),
                _createElementVNode("h4", _hoisted_105, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.deleteStatusTitle')), 1),
                _createElementVNode("p", _hoisted_106, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.deleteConfirmation')), 1)
              ]),
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("div", _hoisted_108, [
                  _cache[52] || (_cache[52] = _createElementVNode("div", { class: "w-6 h-6 bg-red-100 rounded-lg flex items-center justify-center mt-0.5 flex-shrink-0" }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 text-red-600",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("p", _hoisted_110, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.warningTitle')), 1),
                    _createElementVNode("p", _hoisted_111, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.warningMessage')), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.permanentNote')), 1),
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                  class: "px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 text-sm font-medium"
                }, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.cancel')), 1),
                _createElementVNode("button", {
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.deleteStatus && _ctx.deleteStatus(...args))),
                  class: "px-6 py-2 text-white rounded-lg hover:shadow-lg transition-all duration-200 text-sm font-medium shadow-md",
                  style: {"background":"linear-gradient(135deg, #DC2626 0%, #B91C1C 50%, #991B1B 100%)"}
                }, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.delete')), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.toastMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["fixed bottom-4 right-4 max-w-sm rounded-xl shadow-2xl border backdrop-blur-md z-50 transition-all duration-300 transform hover:scale-105", { 
        'bg-emerald-50/95 text-emerald-700 border-emerald-200': _ctx.toastType === 'success',
        'bg-red-50/95 text-red-700 border-red-200': _ctx.toastType === 'error',
        'bg-blue-50/95 text-blue-700 border-blue-200': _ctx.toastType === 'info'
      }])
        }, [
          _createElementVNode("div", _hoisted_115, [
            _createElementVNode("div", _hoisted_116, [
              _createElementVNode("div", {
                class: _normalizeClass(["w-8 h-8 rounded-lg flex items-center justify-center", { 
              'bg-emerald-100': _ctx.toastType === 'success',
              'bg-red-100': _ctx.toastType === 'error',
              'bg-blue-100': _ctx.toastType === 'info'
            }])
              }, [
                (_ctx.toastType === 'success')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_117, _cache[53] || (_cache[53] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M5 13l4 4L19 7"
                      }, null, -1)
                    ])))
                  : (_ctx.toastType === 'error')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_118, _cache[54] || (_cache[54] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_119, _cache[55] || (_cache[55] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        }, null, -1)
                      ])))
              ], 2),
              _createElementVNode("div", _hoisted_120, [
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-sm font-semibold", { 
                  'text-emerald-900': _ctx.toastType === 'success',
                  'text-red-900': _ctx.toastType === 'error',
                  'text-blue-900': _ctx.toastType === 'info'
                }])
                  }, _toDisplayString(_ctx.toastType === 'success' ? _ctx.directT('settings.customersSettings.toastMessages.success') : _ctx.toastType === 'error' ? _ctx.directT('settings.customersSettings.toastMessages.error') : _ctx.directT('settings.customersSettings.toastMessages.information')), 3),
                  _createElementVNode("button", {
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeToast && _ctx.closeToast(...args))),
                    class: "w-6 h-6 rounded-lg hover:bg-black/10 transition-all duration-200 flex items-center justify-center"
                  }, _cache[56] || (_cache[56] = [
                    _createElementVNode("svg", {
                      class: "w-3 h-3",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12"
                      })
                    ], -1)
                  ]))
                ]),
                _createElementVNode("p", _hoisted_122, _toDisplayString(_ctx.toastMessage), 1)
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isAddingCard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/30 backdrop-blur-md",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.cancelCardCreation && _ctx.cancelCardCreation(...args)))
          }),
          _createElementVNode("div", _hoisted_124, [
            (_ctx.currentStep === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("div", _hoisted_127, [
                      _createElementVNode("div", _hoisted_128, [
                        _cache[57] || (_cache[57] = _createElementVNode("div", { class: "w-8 h-8 bg-white/30 rounded-lg flex items-center justify-center border border-white/20" }, [
                          _createElementVNode("svg", {
                            class: "w-4 h-4 text-white",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_129, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.createCustomCard')), 1),
                          _createElementVNode("p", _hoisted_130, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.step1Of2')), 1)
                        ])
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.cancelCardCreation && _ctx.cancelCardCreation(...args))),
                        class: "w-8 h-8 bg-white/30 hover:bg-white/40 rounded-lg flex items-center justify-center transition-all duration-200 border border-white/20"
                      }, _cache[58] || (_cache[58] = [
                        _createElementVNode("svg", {
                          class: "w-4 h-4 text-white",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M6 18L18 6M6 6l12 12"
                          })
                        ], -1)
                      ]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("div", _hoisted_132, [
                      _createElementVNode("div", _hoisted_133, [
                        _cache[59] || (_cache[59] = _createElementVNode("div", { class: "w-16 h-16 bg-gradient-to-br from-blue-100 to-sky-100 rounded-xl flex items-center justify-center mx-auto mb-3 shadow-md" }, [
                          _createElementVNode("svg", {
                            class: "w-8 h-8 text-blue-600",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("h4", _hoisted_134, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.cardInformation')), 1),
                        _createElementVNode("p", _hoisted_135, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.cardInformationDescription')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_136, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_137, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.cardName')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newArea.title) = $event)),
                            type: "text",
                            placeholder: _ctx.directT('settings.customersSettings.cardCreation.cardNamePlaceholder'),
                            class: "w-full px-3 py-2.5 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-100 focus:border-blue-500 bg-gray-50 text-gray-900 transition-all duration-300 placeholder:text-gray-400"
                          }, null, 8, _hoisted_138), [
                            [_vModelText, _ctx.newArea.title]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_139, [
                          _createElementVNode("div", _hoisted_140, [
                            _cache[60] || (_cache[60] = _createElementVNode("div", { class: "w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center" }, [
                              _createElementVNode("svg", {
                                class: "w-4 h-4 text-white",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                                })
                              ])
                            ], -1)),
                            _createElementVNode("div", null, [
                              _createElementVNode("h5", _hoisted_141, _toDisplayString(_ctx.newArea.title || _ctx.directT('settings.customersSettings.cardCreation.cardNamePreview')), 1),
                              _createElementVNode("p", _hoisted_142, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.customCard')), 1)
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_143, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.previewDescription')), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_144, [
                    _createElementVNode("div", _hoisted_145, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.nextStep')), 1),
                    _createElementVNode("div", _hoisted_146, [
                      _createElementVNode("button", {
                        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.cancelCardCreation && _ctx.cancelCardCreation(...args))),
                        class: "px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 text-sm font-medium"
                      }, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.cancel')), 1),
                      _createElementVNode("button", {
                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.proceedToFieldSelection && _ctx.proceedToFieldSelection(...args))),
                        disabled: !_ctx.newArea.title.trim(),
                        class: "px-6 py-2 text-white rounded-lg hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 text-sm font-medium shadow-md disabled:shadow-none",
                        style: {"background":"linear-gradient(135deg, #3B82F6 0%, #2563EB 50%, #1D4ED8 100%)"}
                      }, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.continue')), 9, _hoisted_147)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentStep === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                  _createElementVNode("div", _hoisted_149, [
                    _createElementVNode("div", _hoisted_150, [
                      _createElementVNode("div", _hoisted_151, [
                        _cache[61] || (_cache[61] = _createElementVNode("div", { class: "w-6 h-6 bg-white/30 rounded flex items-center justify-center border border-white/20" }, [
                          _createElementVNode("svg", {
                            class: "w-3 h-3 text-white",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("h4", _hoisted_152, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.addFields')), 1)
                      ]),
                      _createElementVNode("p", _hoisted_153, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.chooseFieldTypes')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_154, [
                      _createElementVNode("div", _hoisted_155, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldTypes, (fieldType) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: fieldType.id,
                            onClick: ($event: any) => (_ctx.selectFieldType(fieldType)),
                            class: "group p-3 text-left bg-white border border-gray-200 rounded-lg hover:border-blue-300 hover:shadow-sm transition-all duration-200"
                          }, [
                            _createElementVNode("div", _hoisted_157, [
                              _createElementVNode("div", _hoisted_158, [
                                (_openBlock(), _createElementBlock("svg", _hoisted_159, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: fieldType.icon
                                  }, null, 8, _hoisted_160)
                                ]))
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_161, _toDisplayString(fieldType.name), 1),
                                _createElementVNode("p", _hoisted_162, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.addFieldType')), 1)
                              ])
                            ])
                          ], 8, _hoisted_156))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_163, [
                    _createElementVNode("div", _hoisted_164, [
                      _createElementVNode("div", _hoisted_165, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_166, [
                            _cache[62] || (_cache[62] = _createElementVNode("div", { class: "w-6 h-6 bg-white/30 rounded flex items-center justify-center border border-white/20" }, [
                              _createElementVNode("svg", {
                                class: "w-3 h-3 text-white",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                                })
                              ])
                            ], -1)),
                            _createElementVNode("h4", _hoisted_167, _toDisplayString(_ctx.newArea.title), 1)
                          ]),
                          _createElementVNode("p", _hoisted_168, _toDisplayString(_ctx.t('settings.customersSettings.fieldsConfigured', { count: _ctx.newArea.fields.length })), 1)
                        ]),
                        _createElementVNode("button", {
                          onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.finishCardCreation && _ctx.finishCardCreation(...args))),
                          disabled: _ctx.newArea.fields.length === 0,
                          class: "px-3 py-1.5 text-xs font-medium text-blue-600 bg-white rounded hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-sm disabled:shadow-none"
                        }, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.saveCard')), 9, _hoisted_169)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_170, [
                      (_ctx.newArea.fields.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
                            _cache[63] || (_cache[63] = _createElementVNode("div", { class: "w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center mx-auto mb-3" }, [
                              _createElementVNode("svg", {
                                class: "w-6 h-6 text-gray-400",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                                })
                              ])
                            ], -1)),
                            _createElementVNode("h5", _hoisted_172, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.noFieldsYet')), 1),
                            _createElementVNode("p", _hoisted_173, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.chooseFromLeft')), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_174, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newArea.fields, (field, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: field.id || index,
                                class: "group p-3 bg-gray-50 border border-gray-200 rounded-lg hover:border-gray-300 hover:shadow-sm transition-all duration-200"
                              }, [
                                _createElementVNode("div", _hoisted_175, [
                                  _createElementVNode("div", _hoisted_176, [
                                    _createElementVNode("div", _hoisted_177, [
                                      _cache[65] || (_cache[65] = _createElementVNode("div", { class: "w-6 h-6 bg-blue-100 rounded flex items-center justify-center" }, [
                                        _createElementVNode("svg", {
                                          class: "w-3 h-3 text-blue-600",
                                          fill: "none",
                                          stroke: "currentColor",
                                          viewBox: "0 0 24 24"
                                        }, [
                                          _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                          })
                                        ])
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_178, [
                                        _createElementVNode("div", _hoisted_179, [
                                          _createElementVNode("span", _hoisted_180, _toDisplayString(field.label), 1),
                                          (field.required)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_181, _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.required')), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_182, [
                                          _createElementVNode("span", _hoisted_183, _toDisplayString(_ctx.getFieldTypeLabel(field.type)), 1),
                                          _cache[64] || (_cache[64] = _createElementVNode("span", { class: "text-gray-400" }, "•", -1)),
                                          _createElementVNode("span", _hoisted_184, _toDisplayString(field.placeholder), 1)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_185, [
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (_ctx.editFieldInCard(index)),
                                      class: "w-6 h-6 bg-blue-100 hover:bg-blue-200 text-blue-600 rounded flex items-center justify-center transition-all duration-200"
                                    }, _cache[66] || (_cache[66] = [
                                      _createElementVNode("svg", {
                                        class: "w-3 h-3",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                        })
                                      ], -1)
                                    ]), 8, _hoisted_186),
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (_ctx.removeFieldFromCard(index)),
                                      class: "w-6 h-6 bg-red-100 hover:bg-red-200 text-red-600 rounded flex items-center justify-center transition-all duration-200"
                                    }, _cache[67] || (_cache[67] = [
                                      _createElementVNode("svg", {
                                        class: "w-3 h-3",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                        })
                                      ], -1)
                                    ]), 8, _hoisted_187)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_188, [
                      _createElementVNode("button", {
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.currentStep = 1)),
                        class: "flex items-center gap-1 px-3 py-1.5 text-gray-600 hover:text-gray-800 transition-colors duration-200 text-sm"
                      }, [
                        _cache[68] || (_cache[68] = _createElementVNode("svg", {
                          class: "w-3 h-3",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M10 19l-7-7m0 0l7-7m-7 7h18"
                          })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.customersSettings.cardCreation.backToCardInfo')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_189, _toDisplayString(_ctx.t('settings.customersSettings.fieldsConfigured', { count: _ctx.newArea.fields.length })), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCustomFieldModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/30 backdrop-blur-md",
            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.closeCustomFieldModal && _ctx.closeCustomFieldModal(...args)))
          }),
          _createElementVNode("div", _hoisted_191, [
            _createElementVNode("div", _hoisted_192, [
              _createElementVNode("div", _hoisted_193, [
                _createElementVNode("div", _hoisted_194, [
                  _cache[69] || (_cache[69] = _createElementVNode("div", { class: "w-8 h-8 bg-white/30 rounded-lg flex items-center justify-center border border-white/20" }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 text-white",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                      }),
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_195, _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.configureFieldTitle')), 1),
                    _createElementVNode("p", _hoisted_196, _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.configureFieldDescription')), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.closeCustomFieldModal && _ctx.closeCustomFieldModal(...args))),
                  class: "w-8 h-8 bg-white/30 hover:bg-white/40 rounded-lg flex items-center justify-center transition-all duration-200 border border-white/20"
                }, _cache[70] || (_cache[70] = [
                  _createElementVNode("svg", {
                    class: "w-4 h-4 text-white",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_197, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_198, _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.fieldLabel')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newField.label) = $event)),
                  type: "text",
                  placeholder: _ctx.directT('settings.customersSettings.fieldTypes.fieldLabelPlaceholder'),
                  class: "w-full px-3 py-2.5 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-100 focus:border-purple-500 bg-gray-50 text-gray-900 transition-all duration-300 placeholder:text-gray-400"
                }, null, 8, _hoisted_199), [
                  [_vModelText, _ctx.newField.label]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_200, _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.fieldType')), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.newField.type) = $event)),
                  class: "w-full px-3 py-2.5 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-100 focus:border-purple-500 bg-gray-50 text-gray-900 transition-all duration-300"
                }, [
                  _createElementVNode("option", _hoisted_201, _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.selectFieldType')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldTypes, (type) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: type.id,
                      value: type.id
                    }, _toDisplayString(type.name), 9, _hoisted_202))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.newField.type]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_203, _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.placeholderText')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.newField.placeholder) = $event)),
                  type: "text",
                  placeholder: _ctx.directT('settings.customersSettings.fieldTypes.placeholderTextPlaceholder'),
                  class: "w-full px-3 py-2.5 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-100 focus:border-purple-500 bg-gray-50 text-gray-900 transition-all duration-300 placeholder:text-gray-400"
                }, null, 8, _hoisted_204), [
                  [_vModelText, _ctx.newField.placeholder]
                ])
              ]),
              _createElementVNode("div", _hoisted_205, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_206, _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.requiredField')), 1),
                  _createElementVNode("p", _hoisted_207, _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.markAsMandatory')), 1)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.newField.required = !_ctx.newField.required)),
                  class: _normalizeClass([
                'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2',
                _ctx.newField.required ? 'bg-red-600' : 'bg-gray-300'
              ])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass([
                  'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
                  _ctx.newField.required ? 'translate-x-5' : 'translate-x-0'
                ])
                  }, null, 2)
                ], 2)
              ]),
              (_ctx.newField.type === 'select' || _ctx.newField.type === 'multiselect')
                ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                    _createElementVNode("div", _hoisted_209, [
                      _cache[71] || (_cache[71] = _createElementVNode("div", { class: "w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center" }, [
                        _createElementVNode("svg", {
                          class: "w-4 h-4 text-purple-600",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M8 9l4-4 4 4m0 6l-4 4-4-4"
                          })
                        ])
                      ], -1)),
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_210, _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.options')), 1),
                        _createElementVNode("p", _hoisted_211, _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.addOptionsDescription')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_212, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newField.options, (option, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "flex items-center gap-2 p-2 bg-white rounded-lg border border-gray-200"
                        }, [
                          _createElementVNode("div", _hoisted_213, _toDisplayString(index + 1), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((_ctx.newField.options[index]) = $event),
                            type: "text",
                            placeholder: _ctx.directT('settings.customersSettings.fieldTypes.optionText'),
                            class: "flex-1 px-2 py-1.5 border border-gray-200 rounded focus:ring-1 focus:ring-purple-100 focus:border-purple-500 bg-gray-50 text-gray-900 transition-all duration-300 text-sm"
                          }, null, 8, _hoisted_214), [
                            [_vModelText, _ctx.newField.options[index]]
                          ]),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.removeOption(index)),
                            class: "w-6 h-6 bg-red-100 hover:bg-red-200 text-red-600 rounded flex items-center justify-center transition-all duration-200"
                          }, _cache[72] || (_cache[72] = [
                            _createElementVNode("svg", {
                              class: "w-3 h-3",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              })
                            ], -1)
                          ]), 8, _hoisted_215)
                        ]))
                      }), 128)),
                      _createElementVNode("button", {
                        onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.addOptionToField && _ctx.addOptionToField(...args))),
                        class: "w-full px-3 py-2 text-purple-600 bg-purple-50 border border-dashed border-purple-200 rounded-lg hover:border-purple-300 hover:bg-purple-100 transition-all duration-200 text-sm font-medium"
                      }, [
                        _createElementVNode("div", _hoisted_216, [
                          _cache[73] || (_cache[73] = _createElementVNode("svg", {
                            class: "w-4 h-4",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                            })
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.addOption')), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_217, [
              _createElementVNode("div", _hoisted_218, _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.configureSettings')), 1),
              _createElementVNode("div", _hoisted_219, [
                _createElementVNode("button", {
                  onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.closeCustomFieldModal && _ctx.closeCustomFieldModal(...args))),
                  class: "px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 text-sm font-medium"
                }, _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.cancel')), 1),
                _createElementVNode("button", {
                  onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.addFieldToCard && _ctx.addFieldToCard(...args))),
                  disabled: !_ctx.newField.label.trim() || !_ctx.newField.type,
                  class: "px-6 py-2 text-white rounded-lg hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 text-sm font-medium shadow-md disabled:shadow-none",
                  style: {"background":"linear-gradient(135deg, #A855F7 0%, #9333EA 50%, #7C3AED 100%)"}
                }, _toDisplayString(_ctx.directT('settings.customersSettings.fieldTypes.addField')), 9, _hoisted_220)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}